<!-- No device types message -->
<div
  class="flex-row align-items-center justify-content-center"
  style="margin: 0 auto; padding: 48px"
  *ngIf="noDeviceTypes && !loading"
>
  {{ 'core.no_device_types_found' | translate }}
</div>

<!-- Table content wrapper with loading overlay -->
<div
  class="table-wrapper"
  [class.loading]="loading"
  [style.min-height.px]="containerHeight"
  *ngIf="!noDeviceTypes"
>
  <!-- Loading overlay - preserves the space while showing loading state -->
  <div class="loading-overlay" *ngIf="loading">
    <div class="loading-content">
      <i class="ri-loader-4-line spin"></i>
      {{ 'core.loading' | translate }}
    </div>
  </div>

  <!-- Table content - visible but dimmed during loading -->
  <table mat-table [dataSource]="items" class="spotlab-table" matSort [class.dimmed]="loading">
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'core.name' | translate | uppercase }}
      </th>
      <td mat-cell *matCellDef="let item">
        {{ item.name }}
      </td>
    </ng-container>

    <ng-container matColumnDef="version">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'core.version' | translate | uppercase }}
      </th>
      <td mat-cell *matCellDef="let item">
        {{ item.version }}
      </td>
    </ng-container>

    <ng-container matColumnDef="numDevices">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'core.num_devices' | translate | uppercase }}
      </th>
      <td mat-cell *matCellDef="let item" class="last-data-cell">
        <ts-loading-attribute
          icon="ri-device-line"
          [value]="item.numDevices"
          class="flex-row align-items-center justify-left"
        ></ts-loading-attribute>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="visibleColumns"></tr>
    <tr mat-row *matRowDef="let item; columns: visibleColumns"></tr>
  </table>
</div>
